import Page from "../page";
import DataCleaning from "../../components/data-cleaning/data-cleaning";

const DataCleaningPage = () => {
  return (
    <Page>
      <DataCleaning />
    </Page>
  );
};

export default DataCleaningPage;
